import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useAppStore } from '../store/appStore';
import { isShellOverlayRoute } from './shellOverlayRoutes';

export const ScrollToTop = () => {
    const { pathname } = useLocation();
    const { activeTab } = useAppStore();
    const previous = useRef({ pathname, activeTab });

    useEffect(() => {
        const last = previous.current;
        previous.current = { pathname, activeTab };

        // Opening or closing an overlay route leaves the tab behind it where the
        // user left it. A tab switch still resets — all tabs share one scroll
        // container — including closing a chapter opened from Home, which lands
        // on the guide tab.
        const overlayHop = activeTab === last.activeTab
            && (isShellOverlayRoute(pathname) || isShellOverlayRoute(last.pathname));
        if (overlayHop) return;

        // Try to scroll the main container first
        const scrollContainer = document.getElementById('main-scroll-container');
        if (scrollContainer) {
            scrollContainer.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
        }

        // Also scroll window as fallback/safeguard
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [pathname, activeTab]);

    return null;
};
